// This is a COPY of aux-services/auth/schema/security.ts. To modify, edit the original and then run aux-services/bin/build-auth.sh
import { PasswordLength } from "./auth-schema";

const passwordOptions = {
    minimumLength: 8,
    maximumLength: PasswordLength,
}

export type PasswordError = 'passwordNoWhitespace' | 'passwordShort' | 'passwordLong' | 'passwordNoVariety' | 'passwordEasyGuess';

export function validateChars(txt: string): boolean {
    return /^[\x20-\uD7FF\uE000-\uFFFD]*$/.test(txt);
}

export function validatePassword(id: string, password: string): PasswordError[] {
    const errors: PasswordError[] = [];
    if (password.length < passwordOptions.minimumLength) errors.push('passwordShort');
    if (password.length > passwordOptions.maximumLength) errors.push('passwordLong');
    if (/^\s|\s$/.test(password) || !validateChars(password)) errors.push('passwordNoWhitespace');

    if (/^[a-z ]+$/.test(password) || /^[A-Z ]+$/.test(password) || /^[0-9]+$/.test(password))
        errors.push('passwordNoVariety');
    if (id && password.includes(id)) errors.push('passwordEasyGuess');
    if (/^p.ssw.r[dt][0-9!]*$/.test(password)) errors.push('passwordEasyGuess');
    if (password.length < 15) {
        if (password.includes('12345')) errors.push('passwordEasyGuess');
        if (password.includes('abc12')) errors.push('passwordEasyGuess');
        if (password.includes('1q2w')) errors.push('passwordEasyGuess');
        if (password.includes('qwert')) errors.push('passwordEasyGuess');
        if (password.includes('asdf')) errors.push('passwordEasyGuess');
    }
    return errors;
}

// This function checks whether the given code is a valid invite code, which by definition will never looks like a hex number.
// This allows you to tell a team invite code from a confirmation code.
export function isInviteCodeNotHex(code: string): boolean {
    return !/^[0-9a-fA-F]+$/.test(code);
}